var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcGoogle = function SvgIcGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M6.411 12.213c0-.649.107-1.27.298-1.854l-3.346-2.57a10 10 0 0 0-1.02 4.424c0 1.59.367 3.09 1.019 4.42l3.344-2.575c-.19-.58-.295-1.2-.295-1.845"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M6.411 12.213c0-.649.107-1.27.298-1.854l-3.346-2.57a10 10 0 0 0-1.02 4.424c0 1.59.367 3.09 1.019 4.42l3.344-2.575c-.19-.58-.295-1.2-.295-1.845"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB4335",
    d: "M12.287 6.312c1.401 0 2.667.5 3.661 1.316l2.893-2.905c-1.763-1.543-4.023-2.496-6.554-2.496A9.91 9.91 0 0 0 3.363 7.79l3.346 2.57a5.86 5.86 0 0 1 5.578-4.047"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M12.287 6.312c1.401 0 2.667.5 3.661 1.316l2.893-2.905c-1.763-1.543-4.023-2.496-6.554-2.496A9.91 9.91 0 0 0 3.363 7.79l3.346 2.57a5.86 5.86 0 0 1 5.578-4.047"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M12.287 18.114a5.86 5.86 0 0 1-5.578-4.047l-3.346 2.57a9.91 9.91 0 0 0 8.924 5.562c2.425 0 4.741-.866 6.479-2.489l-3.177-2.47c-.896.568-2.025.874-3.302.874"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M12.287 18.114a5.86 5.86 0 0 1-5.578-4.047l-3.346 2.57a9.91 9.91 0 0 0 8.924 5.562c2.425 0 4.741-.866 6.479-2.489l-3.177-2.47c-.896.568-2.025.874-3.302.874"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M21.779 12.213c0-.59-.09-1.226-.226-1.816h-9.266v3.858h5.334c-.267 1.316-.993 2.327-2.032 2.985l3.177 2.47c1.826-1.704 3.013-4.242 3.013-7.497"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M21.779 12.213c0-.59-.09-1.226-.226-1.816h-9.266v3.858h5.334c-.267 1.316-.993 2.327-2.032 2.985l3.177 2.47c1.826-1.704 3.013-4.242 3.013-7.497"
  })));
};
export default SvgIcGoogle;